"use strict";

module.exports = function () {
  return this.opts.filterByColumn ? JSON.stringify(this.query) : this.query;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/maestro-vue-tables-2/compiled/computed/q.js
// module id = 388
// module chunks = 0